import { render, staticRenderFns } from "./LahanMitigasiImportModal.vue?vue&type=template&id=1457b66e"
import script from "./LahanMitigasiImportModal.vue?vue&type=script&lang=js"
export * from "./LahanMitigasiImportModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports